<vex-page-layout mode="card">

    <vex-page-layout-header class="pb-16 flex flex-col items-start justify-center">
        <div [class.container]="layoutCtrl.value === 'boxed'"
             [class.px-gutter]="layoutCtrl.value === 'fullwidth'"
             class="w-full flex flex-col sm:flex-row justify-between">
            <div>
                <h1 class="title mt-0 mb-1">{{ "NOTIFICATIONS.TITULO" | translate }}</h1>
                <vex-breadcrumbs
                    [crumbs]="['MENUS.ADMINISTRACION', 'NOTIFICATIONS.TITULO']"></vex-breadcrumbs>
            </div>
        </div>
    </vex-page-layout-header>

    <vex-page-layout-content class="-mt-6">
        <div>
            <form [formGroup]="searchForm">
                <!-- Barra de búsqueda y filtros -->
                <div class="bg-app-bar px-6 py-4 border-b sticky left-0">
                    <!-- Primera fila: Búsqueda y filtros principales -->
                    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-4">
                        <!-- Búsqueda por mensaje -->
                        <div class="md:col-span-2 lg:col-span-2">
                            <label class="text-sm text-secondary mb-1 block">{{ "NOTIFICATIONS.BUSCAR_MENSAJE" | translate }}</label>
                            <div class="bg-foreground rounded-full px-4 h-10 flex items-center border border-gray-300">
                                <mat-icon class="icon-sm text-secondary mr-2" svgIcon="mat:search"></mat-icon>
                                <input formControlName="message"
                                       class="px-2 py-2 border-0 outline-none w-full bg-transparent"
                                       placeholder="{{ 'NOTIFICATIONS.PLACEHOLDER_MENSAJE' | translate }}"
                                       type="search">
                            </div>
                        </div>

                        <!-- Filtro por usuario -->
                        <div>
                            <label class="text-sm text-secondary mb-1 block">{{ "NOTIFICATIONS.USUARIO" | translate }}</label>
                            <div class="bg-foreground rounded px-4 h-10 flex items-center border border-gray-300">
                                <input type="text"
                                       style="width:100% !important"
                                       matInput
                                       formControlName="userId"
                                       placeholder="{{ 'NOTIFICATIONS.SELECCIONAR_USUARIO' | translate }}"
                                       [matAutocomplete]="userAuto">
                                <mat-autocomplete #userAuto="matAutocomplete" [displayWith]="displayUserFn"
                                                  (optionSelected)="onUserSelectionChange($event)">
                                    <mat-option [value]="null">{{ "NOTIFICATIONS.TODOS_USUARIOS" | translate }}</mat-option>
                                    <mat-option *ngFor="let user of filteredUsersList | async" [value]="user">
                                        {{ user.firstName }} {{ user.lastName }} ({{ user.email }})
                                    </mat-option>
                                </mat-autocomplete>
                                <button type="button" *ngIf="searchForm.get('userId').value" matSuffix mat-icon-button
                                        aria-label="Clear" (click)="searchForm.get('userId').setValue(null)">
                                    <mat-icon>close</mat-icon>
                                </button>
                            </div>
                        </div>

                        <!-- Filtro por estado de lectura -->
                        <div>
                            <label class="text-sm text-secondary mb-1 block">{{ "NOTIFICATIONS.ESTADO" | translate }}</label>
                            <div class="bg-foreground rounded px-4 h-10 flex items-center border border-gray-300">
                                <mat-select formControlName="readIt" placeholder="{{ 'NOTIFICATIONS.ESTADO' | translate }}" class="w-full">
                                    <mat-option *ngFor="let option of readStatusOptions" [value]="option.value">
                                        {{ option.label | translate }}
                                    </mat-option>
                                </mat-select>
                            </div>
                        </div>
                    </div>

                    <!-- Segunda fila: Filtros adicionales y botones -->
                    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 items-end">
                        <!-- Filtro por tipo -->
                        <div *ngIf="typeOptions.length > 0">
                            <label class="text-sm text-secondary mb-1 block">{{ "NOTIFICATIONS.TIPO" | translate }}</label>
                            <div class="bg-foreground rounded px-4 h-10 flex items-center border border-gray-300">
                                <mat-select formControlName="type" placeholder="{{ 'NOTIFICATIONS.TIPO' | translate }}" class="w-full">
                                    <mat-option [value]="null">{{ "NOTIFICATIONS.TODOS_TIPOS" | translate }}</mat-option>
                                    <mat-option *ngFor="let type of typeOptions" [value]="type">
                                        {{ type }}
                                    </mat-option>
                                </mat-select>
                            </div>
                        </div>

                        <!-- Filtro por prioridad -->
                        <div>
                            <label class="text-sm text-secondary mb-1 block">{{ "NOTIFICATIONS.PRIORIDAD" | translate }}</label>
                            <div class="bg-foreground rounded px-4 h-10 flex items-center border border-gray-300">
                                <mat-select formControlName="priority" placeholder="{{ 'NOTIFICATIONS.PRIORIDAD' | translate }}" class="w-full">
                                    <mat-option *ngFor="let option of priorityOptions" [value]="option.value">
                                        {{ option.label | translate }}
                                    </mat-option>
                                </mat-select>
                            </div>
                        </div>

                        <!-- Botones de acción -->
                        <div class="md:col-span-2 lg:col-span-2 flex items-end gap-2 justify-end">
                            <button
                                class="flex-none"
                                color="primary"
                                mat-raised-button
                                matTooltip="{{ 'ACTIONS.BUSCAR' | translate }}"
                                type="button"
                                (click)="buscar()">
                                <mat-icon svgIcon="mat:search"></mat-icon>
                                <span class="ml-2">{{ "ACTIONS.BUSCAR" | translate }}</span>
                            </button>

                            <button
                                class="flex-none"
                                color="accent"
                                mat-raised-button
                                matTooltip="{{ 'ACTIONS.LIMPIAR' | translate }}"
                                type="button"
                                (click)="limpiarFiltros()">
                                <mat-icon svgIcon="mat:clear"></mat-icon>
                                <span class="ml-2">{{ "ACTIONS.LIMPIAR" | translate }}</span>
                            </button>

                            <button
                                class="flex-none"
                                color="primary"
                                mat-raised-button
                                matTooltip="{{ 'LABELS.MARK_ALL_AS_READ' | translate }}"
                                type="button"
                                (click)="markAllAsRead()"
                                [disabled]="isLoading">
                                <mat-icon svgIcon="mat:mark_email_read"></mat-icon>
                                <span class="ml-2">{{ "LABELS.MARK_ALL_AS_READ" | translate }}</span>
                            </button>
                        </div>
                    </div>
                </div>

                <!-- Tabla de notificaciones -->
                <div class="relative" *ngIf="isLoading">
                    <div class="absolute inset-0 flex items-center justify-center bg-white bg-opacity-75 z-10">
                        <mat-spinner diameter="50"></mat-spinner>
                    </div>
                </div>

                <table @stagger [dataSource]="dataSource" class="w-full" mat-table matSort>
                    <!-- Columna ID (oculta) -->
                    <ng-container matColumnDef="id">
                        <th *matHeaderCellDef class="uppercase" mat-header-cell mat-sort-header>
                            {{ "GRIDS.ID" | translate }}
                        </th>
                        <td *matCellDef="let row" mat-cell>{{ row.id }}</td>
                    </ng-container>

                    <!-- Columna Nombre del Usuario -->
                    <ng-container matColumnDef="userName">
                        <th *matHeaderCellDef class="uppercase" mat-header-cell mat-sort-header>
                            Nombre
                        </th>
                        <td *matCellDef="let row" class="font-medium" mat-cell>
                            {{ row.userName }}
                        </td>
                    </ng-container>

                    <!-- Columna Mensaje -->
                    <ng-container matColumnDef="message">
                        <th *matHeaderCellDef class="uppercase" mat-header-cell mat-sort-header>
                            {{ "NOTIFICATIONS.MENSAJE" | translate }}
                        </th>
                        <td *matCellDef="let row" mat-cell class="max-w-md truncate">
                            {{ getDisplayMessage(row) }}
                        </td>
                    </ng-container>

                    <!-- Columna Leída -->
                    <ng-container matColumnDef="read_it">
                        <th *matHeaderCellDef class="uppercase" mat-header-cell mat-sort-header>
                            {{ "NOTIFICATIONS.LEIDA" | translate }}
                        </th>
                        <td *matCellDef="let row" mat-cell>
                            <span *ngIf="row.read_it" class="px-2 py-1 rounded text-xs bg-green-100 text-green-800">
                                {{ "NOTIFICATIONS.LEIDAS" | translate }}
                            </span>
                            <span *ngIf="!row.read_it" class="px-2 py-1 rounded text-xs bg-red-100 text-red-800">
                                {{ "NOTIFICATIONS.NO_LEIDAS" | translate }}
                            </span>
                        </td>
                    </ng-container>

                    <!-- Columna Fecha -->
                    <ng-container matColumnDef="created_at">
                        <th *matHeaderCellDef class="uppercase" mat-header-cell mat-sort-header>
                            {{ "NOTIFICATIONS.FECHA" | translate }}
                        </th>
                        <td *matCellDef="let row" mat-cell>
                            {{ formatDate(row.created_at) }}
                        </td>
                    </ng-container>

                    <!-- Columna Acciones -->
                    <ng-container matColumnDef="actions">
                        <th *matHeaderCellDef mat-header-cell>{{ "GRIDS.ACCIONES" | translate }}</th>
                        <td *matCellDef="let row" class="w-10 text-secondary" mat-cell>
                            <button (click)="$event.stopPropagation()"
                                    [matMenuTriggerData]="{ notification: row }"
                                    [matMenuTriggerFor]="actionsMenu"
                                    mat-icon-button
                                    type="button">
                                <mat-icon svgIcon="mat:more_horiz"></mat-icon>
                            </button>
                        </td>
                    </ng-container>

                    <tr *matHeaderRowDef="visibleColumns" mat-header-row></tr>
                    <tr *matRowDef="let row; columns: visibleColumns;" @fadeInUp
                        class="hover:bg-hover trans-ease-out cursor-pointer"
                        (click)="showNotificationDetail(row)"
                        mat-row></tr>
                </table>

                <mat-paginator [pageSizeOptions]="pageSizeOptions" [pageSize]="pageSize" (page)="pageChanged($event)"
                               class="sticky left-0"></mat-paginator>
            </form>
        </div>
    </vex-page-layout-content>
</vex-page-layout>

<mat-menu #actionsMenu="matMenu" xPosition="before" yPosition="below">
    <ng-template let-notification="notification" matMenuContent>
        <button *ngIf="!notification.read_it" (click)="markAsRead(notification)" mat-menu-item>
            <mat-icon svgIcon="mat:mark_email_read"></mat-icon>
            <span>{{ "NOTIFICATIONS.MARCAR_LEIDA" | translate }}</span>
        </button>
        <button *ngIf="notification.read_it" (click)="markAsUnread(notification)" mat-menu-item>
            <mat-icon svgIcon="mat:mark_email_unread"></mat-icon>
            <span>{{ "NOTIFICATIONS.MARCAR_NO_LEIDA" | translate }}</span>
        </button>
        <button (click)="deleteNotification(notification)" mat-menu-item>
            <mat-icon svgIcon="mat:delete"></mat-icon>
            <span>{{ "ACTIONS.ELIMINAR" | translate }}</span>
        </button>
    </ng-template>
</mat-menu>

